import trLocale from 'element-ui/lib/locale/lang/tr-TR'
const tr_tr = {
    common:{
        lostTitle:"Güncel Hatırlatma",
        lostContent:"Geçerli ağ ortamı erişim hakları kısıtlanmıştır. Çin anakarasına hizmet sağlayamıyoruz. Hizmetlerimize erişmek için lütfen ülkenizin ve bölgenizin ilgili düzenlemelerine uyun.",
        connect:"Cüzdanı Bağla",
        walletMsgPro:"Erişmek için lütfen Arbitrum Mainnet'e geçin",
        walletMsgTest:"Erişmek için lütfen Arbitrum Sepolia Testnet'e geçin",
        notice:"Not",
        balance:"Bakiye",
        sign:"İmza",
        confirmByWallet:"Cüzdanda onayla",
        language:"Dil ayarları",
        loading:"Yükleniyor...",
        confirm:"Onayla",
        cancel:"İptal et",
        copySuccess:"Kopyalama başarılı",
        max:"Max",
        min:"Min",
        amount:"Miktar",
        all:"Tüm",
        enterQuantity:"Miktarı girin",
        day:"Gün",
        month:"Ay",
        year:"Yıl",
        years:"Yıl",
        remove:"kaldırmak",
        more:"Daha fazla göster",
    },
    header:{
        home:"Ana Sayfa",
        liquidity:"Likidite",
        locker:"Locker",
        governance:"Yönetim",
        withdraw:"Çek",
        swap:"Swap",
    },
    home:{
        label:"Gerçek Varlıklar<br/><font color='#bdff00'>Finans</font><br/><font color='#bdff00'>Platform</font>",
        globalImpact:"Küresel Etkimizi ve Gelecek Beklentilerimizi Açıklıyoruz.",
        metaAssets:"Web3.0'ın <font color='#bdff00'>Meta Varlıkları</font> 1'de stokla desteklenmektedir",
        tokenization:"RWA tokenizasyonu, <font color='#bdff00'>Gerçek Dünya Varlıklarını</font> (gayrimenkul, sanat, sermaye ve tahviller) dijital tokenlara dönüştürür, bunları sorunsuz bir şekilde blok zincirine entegre eder, verimli arbitraj ve ticareti kolaylaştırır ve içsel gerçek değerleri korur -dünya değeri.",
        liquidity:"<br/> <font color='#bdff00'>Sınırsız Güç</font> ile Likidite ",
        liquidityInfo:"Likiditeyi, gelişmiş likidite için tamamen zincir üzerinde en iyi sipariş defteri ve AMM modellerini sunan yeni bir çözüm olan 1 inç Protokolü kullanarak sağlıyoruz.",
        ecosystemTitle:"<font color='#bdff00'>Ekosistemimiz</font>",
        ecosystemSupported:"Desteklenen Ağlar",
        ecosystemTradingPools:"Ticaret Havuzları",
        ecosystemLiquidity:"Likidite",
        ecosystemOrderbookPairs:"Sipariş Defteri Çiftleri",
        partners:"<font color='#bdff00'>Ortaklarımız</font>",
        standard:"<br/><font color='#bdff00'>Gerçek Dünya Varlıklarının</font> tokenleştirilmesine yönelik yeni standart",
        standard1Title1:"RWA Yatırımcıları",
        standard1Title2:"Karşılaştırmanın Ötesinde Verimlilik",
        standard1Info:"RWA, yatırımcıların yüksek risk kontrolü ve kullanıcı dostu bir kullanıcı arayüzü ile çok çeşitli gerçek dünya varlıklarına erişmesine olanak tanıyacak.",
        standard2Title1:"RWA Topluluğu",
        standard2Title2:"Yönetişim ve Daha Fazlası",
        standard2Info:"RWA sahipleri, karar alma süreçlerine aktif olarak katılmalarına ve güvenli ve şeffaf bir ekosistemde gelişmiş kazanç fırsatlarından faydalanmalarına olanak tanıyan yönetişim ve yüksek getirili protokollere erişebilecek.",
        meeting:"Kullanıcılarla tanışma<br/><font color='#bdff00'>Bulundukları yer</font>",
        discover:"Vizyoner tasarımımızdaki ve kusursuz kullanıcı deneyimimizdeki yeniliği keşfedin",
        meeting1Title:"Vizyonumuza Katılın",
        meeting1Info:"RWA sahipleri tokenlerini stake edebilir ve topluluk içindeki yönetim tekliflerinde aktif olarak yer alabilir.",
        meeting2Title:"Kazancınızı Arttırın",
        meeting2Info:"Topluluğa katılmak, sahiplerin kazanmasına, ücret toplamasına ve ödüller kazanmasına olanak tanır. Daha fazla RWA tokeni toplamak ve portföyünüzü büyütmek için katılımınızı artırın.",
        meeting3Title:"Birleşik Likidite",
        meeting3Info:"RWA finansmanı, kullanımı kolay bir arayüz aracılığıyla gerçek dünyadaki varlıkların ve zincir üstü tokenların likiditesini birleştirir. En düşük kayma ve en hızlı yürütme süreleriyle bunu kusursuz hale getiriyoruz.",
        building:"<br/><font color='#bdff00'>En İyisiyle</font> Oluşturma",
        buildingPartners:"Ekosistem Ortakları",
        buildingInfo:"Kullanıcılara en güçlü zincir içi ticaret deneyimini sunmak için Web3'teki en iyi piyasa yapıcılar, DeFi protokolleri ve L1'ler / L2'ler ile ortaklık yapıyoruz.",
        contact:"Bize Ulaşın",
        joinNow:"Şimdi topluluğumuza katılın!",
        join:"Topluluğa katıl",
    },
    liquidity:{
        deposit:"Yükle",
        withdraw:"Çek",
        add:"Likidite Ekle",
        withdrawable:"Kullanılabilir LP",
        myDeposit:"Mevduatım",
        depositAmount:"Yatırma Tutarı",
        claimableReward:"Talep Edilebilir Ödüller",
        claim:"Talep et",
        pool:"Havuz Detayları",
        totalValue:"USD Toplamı",
        price:"Fiyat",
        contracts:"Sözleşmeler",
        lpAddress:"LP Havuz Adresi",
        rwasAddress:"RWAS Adresi",
        inputDepositAmount:"Yatırılan tutarı girin",
        lpBalanceOut:"Cüzdanda yetersiz LP",
        lpApproveFail:"LP Onayı başarısız oldu",
        depositSuccess:"Para Yatırma Başarılı",
        depositFail:"Para yatırma işlemi başarısız oldu",
        inputRedeemAmount:"Ödeme miktarını girin",
        redeemableBalanceOut:"Yetersiz kullanılabilir miktar",
        redeemSuccess:"Ödeme başarılı",
        redeemFail:"Tekliften yararlanma başarısız oldu",
        inputRwasAmout:"RWAS miktarını girin",
        rwasBalanceOut:"Cüzdanda yetersiz RWAS",
        rwasApproveFail:"RWAS Onayı başarısız oldu",
        inputUsdtAmout:"USDT miktarını girin",
        usdtBalanceOut:"Cüzdanda yetersiz USDT",
        usdtApproveFail:"USDT Onayı başarısız oldu",
        addSuccess:"Likidite ekleme başarılı",
        addFail:"Likidite ekle başarısız oldu",
        rewardEmpty:"Henüz ödül mevcut değil",
        claimSuccess:"Ödülleri Talep Etme Başarılı",
        claimFail:"Ödül talebinde bulunulamadı",
        
        totalLp: "Toplam LP",
        myLp:"LP'm",
        myLpRate:"LP yüzdem",
        removeLpTitle:"Likiditeyi kaldır",
        removeLpTips:"İpucu: Havuzdaki pariteleri kapatmak,pozisyonunuzu havuzdaki payınızla orantılı olarak mevcut oranda temel paritelere dönüştürür. Açılan işlemler ve pozisyonlar, aldığınız tutarlara dahildir.",
        removeAmount:"Tutarı kaldır",
        removeSuccess:"Likiditeyi Kaldırma Başarılı",
        removeFail:"Likiditeyi Kaldırma başarısız",
    },
    locker:{
        info:"Locker, jetonlarınızı belirli bir süre boyunca kilitlemenize olanak tanır. Bu özellik, RWAS <font color='#bdff00'>yönetiminde</font> oy verme hakkını güvence altına almanıza yardımcı olur. Kilitlenme süresi sona erdiğinde kilitli jetonlarınızı çekebilirsiniz.",
        title:"Locker",
        createLock:"Kilit Oluştur",
        increaseLock:"Kilidi Artır",
        increaseAmount:"Tutarı Artır",
        increaseDuration:"Süre uzatma",
        increaseDurationTo:"Süreyi Arttır",
        lockAmount:"Kilitli Tutar",
        lockDuration:"Kilit Süresi",
        myLocker:"Benim Kilidim",
        lockedAmount:"Kilitli Tutar",
        unlock:"Kilidini aç",
        votingPower:"Oylama gücü",
        unlockTime:"Kilit Açma Süresi",
        inputLockAmount:"Kilit miktarını girin",
        lockSuccess:"Kilitleme Başarılı",
        lockFail:"Kilitleme başarısız oldu",
        increaseAmountSuccess:"Tutarı Artırma Başarılı",
        increaseAmountFail:"Tutarı Artırma başarısız oldu",
        outMaxDuration:"Kilit Süresi maksimum 4 yıl olabilir",
        remainTime:"Kalan zaman",
        lessThanRemainTime:"kalan süreden az olamaz",
        increaseDurationSuccess:"Süreyi Artırma Başarılı",
        increaseDurationFail:"Süreyi Artırma başarısız oldu",
        unlockSuccess:"Kilit Açma Başarılı",
        unlockFail:"Kilit açma başarısız oldu",
        lockExpired:"Kilidinizin süresi doldu, lütfen önce kilidini açın",
    },
    governance:{
        info:"Yönetişim modülü, kullanıcıların alanlar oluşturmasına ve bunlara katılmasına, teklifler oluşturup oy vermesine ve puanları görüntülemesine olanak tanır. Tekliflere oy vermek için kullanıcıların veRWAS jetonlarının <font color='#bdff00'>dolapta</font> kilitli olması gerekir.",
        title:"YÖNETİM",
        proposals:"Teklifler",
        createProposal:"Teklif Oluştur",
        autor:"Yazar",
        pending:"Bekleniyor",
        active:"Aktif",
        closed:"Kapalı",
        startTime:"Başlangıç ​​saati",
        endTime:"Bitiş zamanı",
        currentResult:"Mevcut sonuçlar",
        castYourVote:"Oyunuzu verin",
        myVotingPower:"Oy Gücüm",
        vote:"Oy",
        records:"Kayıtlar",
        voter:"Seçmen",
        choice:"Seçenek",
        scores:"Puanlar",
        time:"Zaman",
        newTitle:"Başlık",
        newDesc:"Tanım",
        newChoices:"Seçimler",
        newChoice:"Seçenek",
        optional:"(İsteğe bağlı)",
        noVotePower:"Bu teklif için oy hakkınız yok",
        noChoice:"Lütfen oy vermeden önce bir seçenek seçin",
        voteSuccess:"Oylama Başarılı",
        voteFail:"Oy verme başarısız",
        createSuccess:"Teklif Başarılı Bir Şekilde Oluşturuldu",
        createFail:"Teklif Oluşturma Başarısız",
        votePending:"Oy verme zamanı değil, lütfen sabırla bekleyin",
        voteClosed:"Oylama sona erdi",
        noRecords:"Henüz oylama kaydı yok",
        startIn:"Başla",
        endIn:"Bitiş tarihi",
        day:"Gün",
        hour:"Saat",
        hou:"",
        proposalEmpty:"Henüz bir teklif yok,bir tane oluştur",
        choice1Require:"Seçenek 1 gerekli",
        choice1Error:"Seçenek 1 yanlış doldurulmuş",
        choiceRepeated:"Seçenekler tekrarlanamaz",
        createProposalNeedLimit:"Teklif oluşturmak için en az 50.000 veRWAS'a sahip olmanız gerekir",
        endTimeMustBiger:"Başlangıç zamanı bitiş zamanından daha kısa olmalıdır",
        passed:"Geçti",
        rejected:"Reddedilmiş",
        finalResult:"nihai sonuç",
    },
    swap:{
        title:"Swap ",
        info:"Swap, RWAS ve USDT değişimini kolayca tamamlamanıza yardımcı olabilir. Swap potu Uniswap potuyla tamamen aynıdır.",
        youPay:"Öde",
        youReceive:"Al",
        swapSuccess:"Swap Başarılı",
        swapFail:"Swap başarısız oldu",
    },
    foot:{
        ecosystem:"Ekosistem",
        resources:"Kaynaklar",
        developers:"Geliştiriciler",
        products:"Ürünler",
        baseDoc:"RWA Finansı Hakkında",
        productDoc:"Ürün Açıklaması",
    },
  ...trLocale
}
export default tr_tr